import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./app/App";
import { AppProviders } from "./app/providers";
import "./styles.css";

const root = document.getElementById("root");

if (!root) {
  throw new Error("CarePass member-web root element was not found.");
}

createRoot(root).render(
  <StrictMode>
    <AppProviders><App /></AppProviders>
  </StrictMode>,
);
